import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {AirDatum, GetScoreRequest} from '../models/air-data';
import {environment} from '../../../environments/environment';
import {catchError, map} from 'rxjs/internal/operators';
import {Observable, of} from 'rxjs/index';

@Injectable()
export class AirDataService {

  constructor(private httpClient: HttpClient) {
  }

  getScore({organizationToken, deviceType, deviceId, fromDate, toDate, desc, limit}: GetScoreRequest): Observable<AirDatum[] | {}> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${organizationToken}`});
    const url: string = `${environment.afbV2Host}org-users/self/devices/${deviceType}/${deviceId}/events/score`;
    const params = {
      ...fromDate != null && {fromDate: fromDate.toISOString()},
      ...toDate != null && {toDate: toDate.toISOString()},
      ...desc != null && {desc: desc.toString()},
      ...limit != null && {limit: limit.toString()}
    };

    return this.httpClient
      .get<{ data: AirDatum[] }>(url, {headers, params}).pipe(
        map((response: { data: AirDatum[] }) => response.data),
        catchError((error: HttpErrorResponse) => of([]))
      )
  }
}
